export default __webpack_public_path__ + "static/media/53_3_1.48f516df.png";